<div
    class="notif-row"
    [class.notif-row--alert]="isAlert"
    [class.notif-row--warning]="isWarning"
    [class.notif-row--clickable]="actionLabel"
    (click)="onRowClick()">
    <div class="notif-row__icon" [class.notif-row__icon--fraud]="isFraud">
        <mat-icon>{{ icon }}</mat-icon>
    </div>

    <div class="notif-row__content">
        <div class="notif-row__title-line">
            <span class="notif-row__title">{{ notification.Title }}</span>
            @if (isFraud) {
                <span class="notif-row__fraud-tag">Fraud</span>
            }
        </div>

        <p class="notif-row__body">{{ notification.Body }}</p>

        @if (actionLabel || notification.ExpireDateTime) {
            <div class="notif-row__meta">
                @if (actionLabel) {
                    <span class="notif-row__action">
                        {{ actionLabel }}
                        <mat-icon class="notif-row__chevron">chevron_right</mat-icon>
                    </span>
                }
                @if (notification.ExpireDateTime) {
                    <span class="notif-row__expiry">
                        <mat-icon class="notif-row__clock">schedule</mat-icon>
                        {{ formatExpiry(notification.ExpireDateTime) }}
                    </span>
                }
            </div>
        }
    </div>

    <button
        mat-icon-button
        class="notif-row__dismiss"
        (click)="onDismissClick($event)"
        matTooltip="Dismiss"
        aria-label="Dismiss notification">
        <mat-icon>close</mat-icon>
    </button>
</div>
